import Close from '../src/Close/index.tsx';
export default Close;
